import { type UserProfile_userProfile$data } from '@/__generated__/relay/UserProfile_userProfile.graphql.js';

export type UserRole = {
  id: string;
  name: string;
};

// Role tags expose the underlying Role via `role`; use its global id so
// consumers keyed on the Role id (e.g. losAngeles icon map) keep matching.
export const buildUserRoles = (
  tags: UserProfile_userProfile$data['tags'] | null,
): UserRole[] => {
  return (
    tags?.map((tag) => ({
      id: tag.role?.id ?? tag.id,
      name: tag.name,
    })) ?? []
  );
};
